export const deCoreLabels = {
  buttons: {
    back: "Zurück",
    abbrechen: "Abbrechen",
    clear: "Klar",
    close: "Schließen",
    create: "Erstellen",
    createUser: "Benutzer erstellen",
    delete: "Löschen",
    download: "Herunterladen",
    disableUser: "Benutzer deaktivieren",
    edit: "Bearbeiten",
    enableUser: "Benutzer aktivieren",
    export: "Exportieren",
    import: "Importieren",
    load: "Laden",
    markAsRead: "Als gelesen markieren",
    noAction: "Keine Aktion verfügbar",
    print: "Drucken",
    run: "Lauf",
    save: "Speichern",
    search: "Suche",
    send: "Senden",
    sendNotification: "Benachrichtigung senden",
    toggleUser: "Zustand umkehren",
    upload: "Datei hochladen",
    view: "Ansicht",
  },
  dialog: {
    confirmCloseWithoutSave: "Schließen ohne Speichern?",
    confirmDelete: "Sind Sie sicher, dass Sie löschen möchten?",
    editingConfirm: "Nicht gespeicherte Daten gehen verloren, sind Sie sicher?",
    editingTitle: "Beenden ohne Speichern",
  },
  gen: {
    actions: "Aktionen",
    any: "Jeder",
    all: "Alle",
    backTo: "Zurück zu",
    browse: "Durchsuchen",
    confirmActionText: "Bestätigen Sie die Ausführung der ausgewählten Aktion?",
    confirmActionTitle: "Aktion bestätigen",
    dashboard: "Board",
    deleteConfirm: "Sind Sie sicher, dass Sie löschen möchten",
    deleteObject: "das ausgewählte Objekt?",
    deleteTitle: "Löschen bestätigen",
    devAlert: "Entwicklungsversion",
    developedby: "entwickelt von",
    document: "Dokument",
    editPräfix: "Bearbeiten",
    empty: "Leer",
    errorContact: "Es ist ein Fehler aufgetreten, wenden Sie sich an den Entwickler",
    expirationDaysLeft: "verbleibende Tage",
    expirationExpired: "Abgelaufen",
    expirationNotAvailable: "Nicht erwartet",
    file: "Anhang",
    filePlaceholder: "Wählen Sie eine Datei aus oder ziehen Sie sie hierher",
    files: "Angehängte",
    filter: "Filtern",
    findAddress: "Adresse suchen",
    generals: "Generäle",
    guest: "Gast",
    info: "Informationen",
    inputAddress: "Geben Sie eine Adresse ein",
    loading: "Wird geladen",
    logout: "Ausloggen",
    maintenanceDescription: "Entschuldigen Sie die Unannehmlichkeiten. Wartungsarbeiten sind im Gange, KORU wird bald wieder online sein.",
    maintenanceTitle: "Wir sind bald wieder da!",
    missingPrivileges: "Sie haben nicht die erforderlichen Rechte, um die Seite anzuzeigen",
    newPrefix: "Schaffen",
    no: "Nein",
    noData: "Keine Daten verfügbar",
    ok: "Ok",
    oops: "UPS!",
    pageNotFound: "Die angeforderte Seite ist nicht verfügbar",
    pageResults: "Ergebnisse von [[first]] bis [[last]] von [[totalRecords]] insgesamt",
    profile: "Profil",
    reorder: "Ordnen",
    search: "Suche",
    unknown: "unbekannt",
    user: "Benutzer",
    viewPrefix: "Aussicht",
    yes: "Ja",
  },
  rights: {
    create: "Erstellen",
    deleteAll: "Alle löschen",
    deleteAllowed: "Erlaubtes löschen",
    deleteOwned: "Eigenes löschen",
    readAll: "Alles lesen",
    readAllowed: "Erlaubtes lesen",
    readOwned: "Eigenes lesen",
    updateAll: "Alle ändern",
    updateAllowed: "Erlaubtes ändern",
    updateOwned: "Eigene bearbeiten",
    viewUI: "UI anzeigen",
  },
  navigation: {
    about: "Inforrmation",
    administration: "Verwaltung",
    content: "Inhalt",
    dashboard: "Planke",
    development: "Entwicklung",
    general: "Allgemeines",
    structure: "Struktur",
    tools: "Werkzeuge",
  },
  themes: {
    dim: "Nacht",
    light: "Licht",
    solarized: "Solarisiert",
  },
  toast: {
    error: {
      actionError: "Die Aktion konnte nicht abgeschlossen werden",
      backupDataNotSet: "Sicherungsdaten wurden nicht geladen",
      children: "Es gibt verwandte Artikel",
      create: "Konnte nicht erstellt werden",
      delete: "Konnte nicht gelöscht werden",
      deleteFile: "Die Datei konnte nicht gelöscht werden",
      emailChanged: "E-Mail-Adresse konnte nicht geändert werden",
      feedbackSent: "Das Feedback konnte nicht gesendet werden",
      fiscalCode: "Die Berechnung des Fiskalcodes war nicht möglich",
      generic: "Ein unerwarteter Fehler ist aufgetreten",
      noAction: "Es wurde keine Aktion ausgewählt",
      notificationSent: "Die Benachrichtigung konnte nicht gesendet werden",
      notSupportedFileExtension: "Der hochgeladene Dateityp wird nicht unterstützt",
      passwordChanged: "Passwort konnte nicht geändert werden",
      readFile: "Die Datei konnte nicht gelesen werden",
      reorder: "Die Reihenfolge konnte nicht geändert werden",
      save: "Speichern nicht möglich",
      search: "Konnte nicht suchen",
      sync: "Die Daten wurden von einem anderen Benutzer geändert",
      title: "Fehler!",
      toggleUser: "Fehler beim Ändern des Status",
      uploadFile: "Die Datei konnte nicht hochgeladen werden",
    },
    success: {
      actionSuccess: "Aktion erfolgreich ausgeführt",
      backupDownloadSuccess: "Sicherung erfolgreich erstellt",
      backupRestoreSuccess: "Sicherung erfolgreich wiederhergestellt",
      create: "Erfolgreich erstellt",
      delete: "Löschen erfolgreich",
      deleteFile: "Datei erfolgreich gelöscht",
      emailChanged: "E-Mail-Adresse erfolgreich geändert",
      feedbackSent: "Feedback erfolgreich gesendet",
      generic: "Der Vorgang wurde erfolgreich abgeschlossen",
      notificationSent: "Benachrichtigung erfolgreich gesendet",
      passwordChanged: "Passwort erfolgreich geändert",
      save: "Speichern erfolgreich",
      title: "Fertig!",
      toggleUser: "Status erfolgreich geändert",
      uploadFile: "Die Datei wurde erfolgreich hochgeladen",
    },
    warning: {
      filterMissing: "Alle Filter auswählen",
      formInvalid: "Überprüfe die eingegebenen Felder",
      reverseGeocodingError: "Adresse nicht gefunden",
      searchNoResults: "Keine Ergebnisse gefunden",
      searchTextTooShort: "Geben Sie mindestens 3 Zeichen ein",
      seederNoModules: "Mindestens eine Sammlung auswählen",
      title: "Achtung!",
    },
  },
};
